<template>
  <div class="wrapper">
    <video class="background-video" autoplay loop muted>
      <source src="../videos/logo.mp4" type="video/mp4">
      Your browser does not support the video tag.
    </video>
    <div class="container">
      <div class="left-column" @click="redirectToWebsite" @mouseover="isHoverLeft = true" @mouseleave="isHoverLeft = false">
        <div class="company-info">
          <h2>Company Introduction</h2>
          <p>Welcome to our company!</p>
        </div>
      </div>
      <div class="right-column" @mouseover="isHoverRight = true" @mouseleave="isHoverRight = false">
        <h2>Login</h2>
        <el-form :model="user" :rules="rules" ref="user">
          <el-form-item prop="userName">
            <el-input size="medium" prefix-icon="el-icon-user" v-model="user.userName" placeholder="please enter user name"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input size="medium" prefix-icon="el-icon-lock" v-model="user.password" placeholder="Please enter password" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="login('user')">Log in</el-button>
            <el-button type="primary" size="medium" @click="reguster()">register</el-button>
            <a style="color: #999; font-size: 12px; margin-left: 10px;" @click="showForgotPasswordForm">forget the password?</a>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="bottom-left">
      <a href="#" class="home-link" @click="goToHomepage">Go to Homepage</a>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
import md5 from 'js-md5'

export default {
  name: "Login",
  data() {
    return {
      user: {},
      sendUser:{},
      rules: {
        userName: [
          { required: true, message: 'please enter user name', trigger: 'blur' },
          { min: 3, max: 30, message: '3 to 12 characters in length', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please enter password', trigger: 'blur' },
          { min: 6, max: 20, message: '8 to 20 characters in length', trigger: 'blur' }
        ],
      },
      isHoverLeft: false,
      isHoverRight: false,
    };
  },
  methods: {
    goToHomepage() {
      window.location.href = './index.html';
    },
    redirectToWebsite() {
      // window.location.href = 'https://www.nubway.com/';
    },
    reguster(){
      this.$router.push('/reguster')
    },
    login(formName) {
  
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sendUser.passWorld = md5(this.user.password)
          this.sendUser.userName = this.user.userName
          request.post("/users/login",this.sendUser).then(res =>{
              if(res.code==="USER_NOT"){
                  this.$message.error("The username is incorrect, please re-enter it.")
              }
              else if(res.code==="PASSWORD_NOT"){
                  this.$message.error("Password is wrong, please enter the correct password")
              }
              else if (res.code ==="SUCCESS"){
                  localStorage.setItem("userData", JSON.stringify(res.data));
                  this.$store.state.avatar=res.data.avatar?res.data.avatar:'../images/user.png'
                  this.$message.success("login successful")
                  this.$store.state.teb.userID=res.data.userID
                  this.$router.push('/home')
              }
          })
        } else {
          return false;
        }
      });
    },
    showForgotPasswordForm(){
      this.$router.push('/editPassword')
    }
  },
};
</script>

<style scoped>
.wrapper {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.background-video {
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
  z-index: -1;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 800px;
  z-index: 1; /* Ensure content appears above video */
}

.left-column,
.right-column {
  flex: 1;
  padding: 20px;
  background-color: rgba(43, 41, 43, 0.5); /* 紫色半透明背景 */
  border-radius: 10px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: transform 0.5s ease, box-shadow 0.5s ease;
  transform-origin: center center;
  transform: perspective(1000px) scale(1.1) rotateY(30deg);
}

.left-column:hover {
  transform: perspective(1000px) scale(1.2) rotateY(0deg);
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
}

.right-column:hover {
  transform: perspective(1000px) scale(1.2) rotateY(0deg);
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
}

.company-info {
  text-align: center;
  transition: transform 0.5s ease;
}

.company-info:hover {
  transform: scale(1.1) rotateY(-5deg);
}

.el-input {
  margin-bottom: 10px;
}

.el-button {
  margin-top: 10px;
}
.bottom-left {
  position: fixed;
  bottom: 10px;
  left: 10px;
}
</style>